module.exports = __webpack_public_path__ + "img/twismPattern.68557abc.svg";